// extracted by mini-css-extract-plugin
module.exports = {"header":"LetterHeader_header__3tnNs","headerButtons":"LetterHeader_headerButtons__2S_69","headerPart":"LetterHeader_headerPart__Vncou"};